"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiteralJsonSchemaPropertyType = void 0;
exports.LiteralJsonSchemaPropertyType = {
    Boolean: "boolean",
    String: "string",
    Integer: "integer",
    Number: "number",
};
